import { createFileRoute, Outlet } from "@tanstack/react-router";

/**
 * Layout sin metadatos: el índice vive en `consultas-resueltas.index.tsx` y
 * cada consulta en `consultas-resueltas.$sector.$pregunta.tsx`. Si este layout
 * declarara canonical/hreflang, se concatenarían con los de la hoja y Google
 * vería dos canonical en la misma página.
 */
export const Route = createFileRoute("/consultas-resueltas")({
  component: () => <Outlet />,
});
